import React from 'react'
import Back from '../../components/img/back.png'
function BackToRange() {
  return (
    <div className='back-btn'><a href="./Pool-Range"><img src={Back} alt="Back to range"/></a></div>
  )
}

export default BackToRange
